"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.2918 16.9583L21.5418 29.7292L15.7084 23.8958C15.4155 23.6032 15.0183 23.4389 14.6043 23.4389C14.1902 23.4389 13.7931 23.6032 13.5001 23.8958C13.3527 24.0395 13.2355 24.2112 13.1555 24.4008C13.0755 24.5904 13.0343 24.7942 13.0343 25C13.0343 25.2058 13.0755 25.4095 13.1555 25.5992C13.2355 25.7888 13.3527 25.9605 13.5001 26.1042L20.4376 33.0417C20.7303 33.3348 21.1275 33.4996 21.5418 33.5C21.9543 33.491 22.3483 33.3274 22.6459 33.0417L36.5001 19.1667C36.6475 19.023 36.7647 18.8513 36.8447 18.6617C36.9246 18.472 36.9659 18.2683 36.9659 18.0625C36.9659 17.8567 36.9246 17.6529 36.8447 17.4633C36.7647 17.2737 36.6475 17.102 36.5001 16.9583C36.2071 16.6657 35.81 16.5014 35.3959 16.5014C34.9819 16.5014 34.5847 16.6657 34.2918 16.9583Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 4.16666C20.8796 4.16666 16.8517 5.38851 13.4257 7.67771C9.99969 9.9669 7.32943 13.2206 5.7526 17.0274C4.17577 20.8342 3.76321 25.0231 4.56706 29.0644C5.37092 33.1056 7.35511 36.8178 10.2687 39.7314C13.1823 42.645 16.8944 44.6292 20.9357 45.433C24.977 46.2369 29.1659 45.8243 32.9727 44.2475C36.7795 42.6707 40.0332 40.0004 42.3224 36.5744C44.6116 33.1483 45.8334 29.1204 45.8334 25C45.8334 22.2641 45.2946 19.555 44.2476 17.0274C43.2006 14.4998 41.666 12.2032 39.7315 10.2686C37.7969 8.33404 35.5003 6.79947 32.9727 5.7525C30.445 4.70553 27.736 4.16666 25.0001 4.16666ZM25.0001 42.625C21.5042 42.625 18.0869 41.5878 15.1807 39.6447C12.2745 37.7016 10.0102 34.94 8.67427 31.7094C7.33836 28.4788 6.99094 24.9245 7.67599 21.4964C8.36105 18.0682 10.0478 14.9204 12.5227 12.4514C14.9976 9.9823 18.1494 8.30301 21.5791 7.62605C25.0088 6.94909 28.5623 7.3049 31.7898 8.64844C35.0172 9.99198 37.7734 12.2628 39.7097 15.1736C41.6459 18.0843 42.675 21.5041 42.6668 25C42.6668 29.6855 40.8055 34.1791 37.4923 37.4922C34.1792 40.8054 29.6856 42.6667 25.0001 42.6667V42.625Z",
    fill: fill
  }));
};

exports["default"] = _default;